export default state => state.payment.availableCategoriesToPaymentOptionsMap;
